import React from "react";
import { Stack, Typography, styled, TextField, Button } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AvatarWithEdit } from "../inputs";

const Card = styled(Stack)(({ theme }: any) => ({
  backgroundColor: theme.palette.common.white,
  border: `1px solid ${theme.palette.common.borderGrey}`,
  "& .button": {
    fontSize: theme.spacing(2),
    height: "40px",
    borderRadius: "30px",
    fontWeight: 400,
  },
  "& .styledTextfield": {
    "& .MuiInputBase-root": {
      padding: "10px",
      fontWeight: 700,
      borderBottom: `1px solid ${theme.palette.common.borderGrey}`,
    },
  },
}));

const SCHEMA = {
  name: Yup.string().required("Field is Required"),
  position: Yup.string().required("Field is Required"),
  company: Yup.string().required("Field is Required"),
};
export interface SpeakerDetailCardInterface {
  image: string;
  name: string;
  position: string;
  company: string;
  handleAction: (data: any) => void;
}

const SpeakerDetailCard = ({
  image,
  name,
  position,
  company,
  handleAction,
}: SpeakerDetailCardInterface) => {
  const initialData = { name, position, company };
  const { values, handleChange, handleBlur, handleSubmit, touched, errors } =
    useFormik({
      initialValues: initialData,
      validationSchema: Yup.object().shape(SCHEMA),
      onSubmit: (value) => handleAction(value),
    });
  return (
    <Card
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      padding="10px 25px"
      minWidth="636px"
      width="100%"
      height="100px"
      spacing={3}
    >
      <AvatarWithEdit src={image} size={60} id="122" onEdit={() => null} />
      <Stack width="100%">
        <Typography color={(theme: any) => theme.palette.common.grey}>
          Name
        </Typography>
        <TextField
          className={"styledTextfield"}
          variant="standard"
          style={{ padding: 0, border: 0 }}
          name="name"
          id="name"
          placeholder="name"
          helperText={touched.name ? errors.name : ""}
          error={touched.name && Boolean(errors.name)}
          value={values.name}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </Stack>
      <Stack width="100%">
        <Typography color={(theme: any) => theme.palette.common.grey}>
          Position
        </Typography>
        <TextField
          className={"styledTextfield"}
          variant="standard"
          style={{ padding: 0, border: 0 }}
          name="position"
          id="position"
          placeholder="position"
          helperText={touched.position ? errors.position : ""}
          error={touched.position && Boolean(errors.position)}
          value={values.position}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </Stack>
      <Stack width="100%">
        <Typography color={(theme: any) => theme.palette.common.grey}>
          Company
        </Typography>
        <TextField
          className={"styledTextfield"}
          variant="standard"
          style={{ padding: 0, border: 0 }}
          name="company"
          id="company"
          placeholder="company"
          helperText={touched.company ? errors.company : ""}
          error={touched.company && Boolean(errors.company)}
          value={values.company}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </Stack>
      <Button
        color="primary"
        variant="contained"
        className="button"
        onClick={() => handleSubmit()}
      >
        Save
      </Button>
    </Card>
  );
};
export default SpeakerDetailCard;
